import { Button, IconButton, InputAdornment, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import {
	AddOutlined,
	ArrowBackIosOutlined,
	ArrowForwardIosOutlined,
	CalendarToday,
	Clear,
	Search
} from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import clsx from 'clsx'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import useQuery from '../../../../hooks/useQuery'
import { FilterButton } from '../../Components/Schedule/FilterButton'
import { GroomingFilterButton } from '../../Components/Schedule/GroomingFilterButton'
import { GroomingFilters } from '../../Components/Schedule/GroomingFilters'
import { SelectedFilters } from '../../Components/Schedule/SelectedFilters'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarItemsWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		'& > *': {
			marginRight: '16px',
			marginBottom: 8
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '19px 25px 16px 25px !important'
	},
	searchField: {
		minWidth: 150
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	filterButton: {
		zIndex: 1
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	scheduleAggregatesWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		paddingTop: '10px',
		paddingBottom: '12px'
	},
	scheduleAggregate: {
		display: 'flex',
		width: '23%',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		padding: '10px 16px',
		borderRadius: 6,
		color: '#4D4C4F',
		marginRight: 8,
		marginBottom: 8,
		background: '#F3F3F3'
	},
	membershipWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	membershipIcon: {
		color: '#6B4AD6',
		'&::before': {
			fontSize: '14px',
			lineHeight: '14px'
		}
	},
	membershipType: {
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#777679',
		textTransform: 'capitalize'
	},
	filterIcon: {
		fontSize: 19,
		color: '#777679',
		marginRight: 8
	},
	filterButtonLabel: {
		alignItems: 'center'
	},
	noWrap: {
		whiteSpace: 'nowrap'
	}
}))

export const ScheduledVisitsToolbar = React.forwardRef((props, ref) => {
	const classes = useStyles()
	const theme = useTheme()
	const history = useHistory()
	const params = useParams()

	const [search, setSearch] = useState('')
	const [isOpen, setIsOpen] = useState(false)
	const { pushQueryParamToHistory } = useQuery()

	let { tableRef, date, scheduleAggregates, setDate, changeDate } = props

	const updateDate = (date) => {
		pushQueryParamToHistory({ key: 'date', value: moment(date).format('YYYY-MM-DD') })
		setDate(moment(date).format('ll'))
		setIsOpen(false)
	}

	const onSearchChange = (searchText) => {
		tableRef.current.dataManager.changeSearchText(searchText)
		tableRef.current.onSearchChangeDebounce(searchText)
	}

	useEffect(() => {
		onSearchChange(search)
	}, [search])

	return (
		<div ref={ref} className={classes.toolbarWrapper}>
			<Toolbar className={classes.toolbar}>
				<div className={classes.toolbarItemsWrapper}>
					<Typography
						variant="h6"
						color="primary"
						style={{
							fontSize: '22px',
							fontWeight: 800,
							lineHeight: '30px',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis'
						}}>
						{props.grooming ? 'Grooming Schedule' : 'Schedule'}
					</Typography>
					<TextField
						value={search}
						className={classes.searchField}
						onChange={(event) => setSearch(event.target.value)}
						placeholder="Search"
						variant="filled"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<Tooltip title="Search">
										<Search fontSize="small" />
									</Tooltip>
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										disabled={!search}
										onClick={() => setSearch('')}
										aria-label="Clear">
										<Clear fontSize="small" aria-label="clear" />
									</IconButton>
								</InputAdornment>
							),
							inputProps: {
								'aria-label': 'Search'
							}
						}}
					/>
					{/* Schedule filter button */}
					{props.grooming ? <GroomingFilterButton /> : <FilterButton />}
					<div className={classes.datePickerContainer}>
						<Button
							className={clsx(classes.headerButton, classes.calendarDateButton)}
							onClick={() => setIsOpen(true)}
							variant="outlined"
							endIcon={<CalendarToday style={{ height: 19, width: 19, fill: '#777679' }} />}
							classes={{
								label: classes.noWrap
							}}
							size="large">
							{moment(date).format('MMM D, YYYY')}
						</Button>
						<KeyboardDatePicker
							disableToolbar
							open={isOpen}
							onOpen={() => setIsOpen(true)}
							onClose={() => setIsOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							id="start-date"
							label="Start Date"
							inputVariant="filled"
							value={date}
							onChange={updateDate}
							className={classes.datePicker}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'Start Date',
								className: classes.calendarButton
							}}
						/>
					</div>
					<div style={{ display: 'flex' }}>
						<IconButton
							className={classes.dateChangeButton}
							onClick={() => changeDate('subtract')}
							style={{ marginRight: 8 }}>
							<ArrowBackIosOutlined style={{ fill: '#777679' }} />
						</IconButton>
						<IconButton className={classes.dateChangeButton} onClick={() => changeDate('add')}>
							<ArrowForwardIosOutlined style={{ fill: '#777679' }} />
						</IconButton>
					</div>
					<Button
						variant="outlined"
						className={clsx(classes.headerButton, classes.addAppointmentButton)}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
						size="large"
						onClick={() => {
							if (props.grooming) {
								history.push(`/facilities/${params.facilityId}/appointment/create?type=grooming`)
							} else {
								history.push(`/facilities/${params.facilityId}/appointment/create`)
							}
						}}>
						Appointment
					</Button>
				</div>
			</Toolbar>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					padding: '16px 25px',
					borderTop: '1px solid #D0CFD2'
				}}>
				<div>
					<Typography variant="overline">Today’s Stats</Typography>
				</div>
				<div className={classes.scheduleAggregatesWrapper}>
					{scheduleAggregates
						? Object.keys(scheduleAggregates).map((aggregate) => (
							<div className={classes.scheduleAggregate} key={aggregate}>
								<Typography
									style={{
										lineHeight: '19px',
										fontWeight: 600,
										fontSize: '14px',
										textTransform: 'capitalize'
									}}>
									{props.grooming ? scheduleAggregates[aggregate].label : aggregate.split('_').join(' ')}
								</Typography>
								<Typography
									style={{
										fontWeight: 800,
										fontSize: '16px',
										lineHeight: '22px'
									}}>
									{scheduleAggregates[aggregate].value}
								</Typography>
							</div>
						))
						: null}
				</div>
				<div style={{ display: 'flex' }}>
					<Typography style={{ marginRight: 8 }} variant="overline">
						Appointments
					</Typography>
					{props.grooming ? <GroomingFilters /> : <SelectedFilters />}
				</div>
			</div>
		</div>
	)
})
